<template>
    <div class="columns-box">
        <h2 class="heading"><a :href="$store.state.hrefPrefix + '/category/news'">{{ $t("MOST_POPULAR") }}</a></h2>
        <div class="most-popular msite-hide">
            <most-popular-article v-for="article in articles" :article="article"></most-popular-article>
        </div>

        <div class="columns-box-msite">
            <div class="columns-box-slider">
                <div class="columns-box-item">
                    <most-popular-article v-for="article in articles" :article="article"></most-popular-article>

                </div>
<!--                <div class="columns-box-item">-->
<!--                    <most-popular-article v-for="article in article" :article="article"></most-popular-article>-->
<!--                </div>-->
            </div>
        </div>

    </div>
</template>

<script>
import MostPopularArticle from "@/parts/home/MostPopularArticle.vue";

export default {
    name: "MostPopular",
    components: {MostPopularArticle},
    props: {
        articles: {
            type: Object,
            default: null
        },
    }
}
</script>

<style scoped>

</style>
